import { render, staticRenderFns } from "./AddNewEvent.vue?vue&type=template&id=36845d67&"
import script from "./AddNewEvent.vue?vue&type=script&lang=js&"
export * from "./AddNewEvent.vue?vue&type=script&lang=js&"
import style0 from "./AddNewEvent.vue?vue&type=style&index=0&id=36845d67&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports